<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="16"
        viewBox="0 0 18 16"
        fill="none"
    >
        <path
            d="M5.94 1.10001V12.75"
            stroke="#8E8E93"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M12.04 3.23001V14.88"
            stroke="#8E8E93"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M1.80999 1.97L5.61999 1.12C5.82999 1.07 6.03999 1.09 6.23999 1.16L11.74 3.16C11.9386 3.23208 12.1537 3.24595 12.36 3.2L15.69 2.46C15.8527 2.42396 16.0215 2.42503 16.1838 2.46313C16.346 2.50124 16.4976 2.57539 16.6273 2.6801C16.757 2.78481 16.8614 2.91738 16.9329 3.06798C17.0043 3.21857 17.0409 3.38332 17.04 3.55V12.93C17.0391 13.182 16.9525 13.4263 16.7944 13.6226C16.6363 13.8189 16.4161 13.9555 16.17 14.01L12.36 14.86C12.15 14.91 11.94 14.89 11.74 14.82L6.23999 12.82C6.04134 12.7479 5.82625 12.734 5.61999 12.78L2.28999 13.52C2.12725 13.556 1.95849 13.555 1.79622 13.5169C1.63395 13.4788 1.48235 13.4046 1.35267 13.2999C1.22298 13.1952 1.11854 13.0626 1.0471 12.912C0.975659 12.7614 0.93905 12.5967 0.93999 12.43V3.05C0.94084 2.79795 1.02745 2.55369 1.18557 2.35741C1.34369 2.16112 1.5639 2.02449 1.80999 1.97Z"
            stroke="#8E8E93"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
